<template>
  <el-dialog width="40%" ref="dialog" :visible.sync="localVisible" @close="close">
    <div slot="title">{{ title }}</div>

    <div>{{ message }}</div>

    <el-radio-group v-if="options" v-model="choosenOption" class="options">
      <el-radio
        v-for="(item, index) in options"
        :key="index"
        :label="index"
        class="options__item"
      >{{ item }}</el-radio>
    </el-radio-group>

    <v-row slot="footer" justify="between">
      <v-button
        theme="primary"
        view="transparent"
        @click="cancel"
      >{{ cancelButtonText ? cancelButtonText : $t('c.dialog.buttonCancel') }}</v-button>
      <v-button
        theme="primary"
        @click="confirm"
      >{{ confirmButtonText ? confirmButtonText : $t('c.dialog.buttonConfirm') }}</v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VRow from '@/components/common/VRow.vue'
import visibleMixin from '@/mixins/visible'

export default {
  name: 'VSmartConfirmationDialog',

  mixins: [visibleMixin],
  components: { VRow },

  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    confirmButtonText: {
      type: String
    },
    cancelButtonText: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      choosenOption: 0
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel', this.options.length ? this.choosenOption : null)
      this.close()
    },
    confirm() {
      this.$emit('confirm', this.options.length ? this.choosenOption : null)
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.options {
  display: flex;
  flex-direction: column;
  margin: 16px 0 0;
}
.options__item {
  margin-top: 16px;
}
</style>
